/* eslint-disable */
import { createHttpClient } from './http'

let httpClient = null

export function initVerifiedHttpClient(baseUrl) {
  httpClient = createHttpClient(baseUrl + '/api/verified_service/v1')
  return httpClient
}

/** @deprecated Use initVerifiedHttpClient instead. */
export function initVerifiedAxios(baseUrl) {
  return initVerifiedHttpClient(baseUrl)
}

export default httpClient

export function searchLicensee(query, limit = 100) {
  query.size = limit
  return httpClient.post('/search_licensee', removeFalsyValues(query))
}

function removeFalsyValues(obj) {
  let newObj = {}
  Object.keys(obj).forEach(key => {
    if (obj[key]) {
      newObj[key] = obj[key]
    }
  })
  return newObj
}



// WEBPACK FOOTER //
// ./src/verifiedapi.js